import { StyleSheet } from "react-native";
import { AppTheme } from "../../theme";

export const receiptSettingsScreenStyle = (theme: AppTheme) => StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: theme?.lightBackgroundColor,
    },
    scrollContent: {
        paddingBottom: 30,
    },
    sectionsWrapper: {
        gap: 16,
        marginHorizontal: 12,
        marginTop: 12,
    },
    column: {
        gap: 16,
    },
    card: {
        backgroundColor: theme?.light,
        borderRadius: 12,
        padding: 16,
        elevation: 2,
        shadowColor: theme?.dark,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
    },
    cardTitle: {
        marginBottom: 4,
    },
    cardSubTitle: {
        marginBottom: 16,
    },
    // ── Header actions ───────────────────────────────────────────────────────
    headerActions: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        columnGap: 10,
    },
    headerButtonContainer: {
        borderRadius: 10,
    },
    outlineButton: {
        backgroundColor: theme?.light,
        borderRadius: 10,
    },
    primaryButton: {
        backgroundColor: theme?.primary,
        borderRadius: 10,
    },
    disabledButton: {
        backgroundColor: theme?.lightGrey,
        borderRadius: 10,
    },
    // ── Receipt type segmented control ───────────────────────────────────────
    segmentContainer: {
        flexDirection: "row",
        padding: 4,
        gap: 4,
        borderRadius: 10,
        backgroundColor: theme?.lightBackgroundColor,
    },
    segment: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        paddingVertical: 10,
        borderRadius: 8,
        minHeight: 44,
    },
    segmentActive: {
        backgroundColor: theme?.light,
        elevation: 2,
        shadowColor: theme?.dark,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.08,
        shadowRadius: 4,
    },
    // ── Fields & rows ────────────────────────────────────────────────────────
    helperText: {
        marginTop: 2,
    },
    editorHelper: {
        marginTop: -10,
        marginBottom: 15,
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: 12,
        paddingHorizontal: 12,
        backgroundColor: theme?.lightBackgroundColor,
        borderRadius: 8,
        minHeight: 48,
    },
    rowIcon: {
        width: 34,
        height: 34,
        borderRadius: 8,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme?.tealPrimary,
        marginRight: 12,
    },
    rowLabelWrapper: {
        flex: 1,
        marginRight: 10,
    },
    rowGroup: {
        gap: 12,
    },
    infoNote: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 8,
        padding: 10,
        borderRadius: 8,
        backgroundColor: theme?.lightPrimary,
        marginBottom: 16,
    },
    // ── Preview ──────────────────────────────────────────────────────────────
    previewPaper: {
        borderRadius: 8,
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: theme?.borderColor,
        overflow: "hidden",
    },
    previewModal: {
        flex: 1,
        backgroundColor: theme?.lightBackgroundColor,
    },
    previewModalContent: {
        alignSelf: "center",
        marginVertical: 16,
        borderRadius: 12,
        overflow: "hidden",
        backgroundColor: theme?.light,
    },
    skeletonCard: {
        gap: 12,
    },
});
